'use strict';

const jQuery = require('jquery');
const _ = require('lodash');

const FormBuilder = require('./../builder');

let ElementClass = require('./../elementClass');

FormBuilder.register('checkbox', function(config) {
  let self = {};

  self = new ElementClass(config);
  self.isScalar = false;

  self.checked = [];
  self.options = [];
  self.isBoolean = false;

  if ((/number|string/).test(typeof config.options)) {
    self.options = [config.options];
    self.isScalar = true;
  } else if ('object' === typeof config.options) {
    self.options = config.options;
  }

  if ((/number|string/).test(typeof config.value)) {
    self.checked = [config.value];
  } else if ('object' === typeof config.value) {
    self.checked = config.value;
  } else if (_.isBoolean(config.value)) {
    self.isBoolean = true;
    self.isScalar = true;
    self.options.push([config.label]);
    if (config.value) {
      self.checked = ['0'];
    }
  }

  self.render = function($wrap) {
    if (self.options.length > 1) {
      self.name = self.name + '[]';
    }

    _.forEach(self.options, function(option, key) {
      let $div = jQuery('<div/>');
      let $checkbox = jQuery('<input/>');
      let $label = jQuery('<label/>').append(jQuery('<span class="cloud-control-indicator"></span><span class="cloud-label"></span>'));

      if (config.sub_wrap_class) {
        $div.addClass(config.sub_wrap_class);
      }

      if (self.elementClass) {
        $checkbox.addClass(self.elementClass);
      }

      if (self.labelClass) {
        $label.addClass(self.labelClass);
      }

      if (config.disabled) {
        $checkbox.prop('disabled', true);
      }

      if (config.tooltip) {
        $label.attr('title', config.tooltip);
      }

      if (typeof config.onChange === 'function') {
        $checkbox.on('change', config.onChange);
      }

      if (typeof config.onClick === 'function') {
        $wrap.on('click', config.onClick);
      }

      $checkbox.attr('type', 'checkbox');
      $checkbox.attr('name', self.name);
      $checkbox.attr('value', key);
      $label.prepend($checkbox);
      $label.find('.cloud-label').text(option);
      $div.append($label);

      $wrap.append($div);
    });

    $wrap.find('input[type=checkbox]').each(function() {
      let input = jQuery(this);

      if (-1 !== self.checked.indexOf(input.val())) {
        input.prop('checked', true);
      }
    });
  };

  self.getData = function() {
    let data = (self.isBoolean) ? false : [];

    self.$.find('input').each(function() {
      let $input = jQuery(this);

      if ($input.is(':checked')) {
        if (true === self.isScalar) {
          data = self.isBoolean ? true : $input.val();

          return false;
        }

        data.push($input.val());
      }
    });

    return (true === self.isScalar) ? data : ((data.length > 0) ? data : null);
  };

  return self;
});
